import Store from 'store';
import moment from 'moment';
import { navigateToUrl } from 'single-spa';

import {
  isLoggedIn,
  invalidateSession,
  getAccessToken,
  isSessionExpired,
  refreshSession,
  getTokenExpiry,
} from 'mf-shared/utils/auth';
import { getFeatureFlagsFromService } from 'mf-shared/utils/featureFlags';
import { isExternalRedirect } from 'mf-shared/utils/sso';
import { startsWith } from 'mf-config/client';
import config from 'mf-config/dist/apps.config.json';

/*
 * Retrieving auth information from local storage to query from Optimizely
 * once before importing any other code.
 *
 * We need to do this here because of the `hasFeature` util function. Feature
 * flags have to be loaded before any call to `hasFeature` is done. That needs
 * to be revised later.
 *
 * This ensures the entire app will have the correct set of feature flags
 * before even rendering.
 *
 * TODO: This won't be needed if all flags are used in runtime.
 */
export function setFlagsWithUser() {
  const { id, email } = Store.get('response:login') || {};
  getFeatureFlagsFromService(id, {
    email,
  });
}

/*
 * Periodically check if token needs to be refreshed.
 * Refresh if when it's <= 5 minutes before expiry.
 */
export function registerSessionRefresher() {
  window.addEventListener('single-spa:before-first-mount', () => {
    setInterval(() => {
      if (isLoggedIn()) {
        const minutesLeftUntilExpiry = moment(getTokenExpiry()).diff(
          moment(),
          'minute'
        );

        if (minutesLeftUntilExpiry <= 5) {
          refreshSession();
        }
      }
    }, 30 * 1000); // 30 seconds
  });
}

/*
 * Quick authentication for returning users.
 * If current user has a valid session, redirect the user to main app directly.
 */
export function registerUserAuthenticator() {
  window.addEventListener('single-spa:before-routing-event', () => {
    const sessionInvalidating = startsWith(
      window.location,
      ...config.BoOneTimeResponseApp.routes
    );

    if (sessionInvalidating) {
      invalidateSession();
      return;
    }

    const hasValidSession = isLoggedIn();
    const hasExpiredToken = isSessionExpired();

    // If session expired, invalidate the session directly
    if (hasValidSession && hasExpiredToken) {
      invalidateSession();
      return;
    }

    const sessionRequired = !startsWith(
      window.location,
      ...config.BoAuthApp.routes
    );

    if (!sessionRequired && hasValidSession) {
      const next = new URL(document.location.toString()).searchParams.get(
        'next'
      );

      if (next && isExternalRedirect(next)) {
        navigateToUrl('/');
      } else if (next === 'gostore-merchant') {
        const accessToken = getAccessToken();
        window.location.href = `${process.env.GOSTORE_AUTH_URL}?token=${accessToken}`;
      } else if (next) {
        navigateToUrl(next);
      } else {
        navigateToUrl('/');
      }
    }
    setFlagsWithUser();
  });
}
